import { NgModule } from '@angular/core';
import { IssuesExtListComponent } from './issues-ext-list/issues-ext-list.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../core/shared/shared.module';
import { IssuesExtRest } from './issues-ext.rest';
import { IssuesExtRouting } from './issues-ext.routing';
import { IssueExtDetailsComponent } from './issues-ext-details/issue-ext-details/issue-ext-details.component';
import { IssueExtHeaderComponent } from './issues-ext-details/issue-ext-header/issue-ext-header.component';
import { IssueExtElementsComponent } from './issues-ext-details/issue-ext-elements/issue-ext-elements.component';
import { IssueExtElementModalComponent } from './issues-ext-details/issue-ext-element-modal/issue-ext-element-modal.component';
import { ProjectsRest } from '../projects/projects.rest';
import { CustomersRest } from '../company/customers/customers.rest';
import { CustomersListModule } from '../company/customers/customers-list/customers-list.module';
import { ProjectsRowsModule } from '../projects/project-rows/project-rows.module';
import { EmployeesModule } from '../company/employees/employes.module';

@NgModule({
    imports: [
    CommonModule,
    IssuesExtRouting,
    SharedModule,
    CustomersListModule,
    ProjectsRowsModule,
    EmployeesModule
    ],
    exports: [
        IssuesExtListComponent,
        IssueExtDetailsComponent,
        IssueExtHeaderComponent,
        IssueExtElementsComponent,
        IssueExtElementModalComponent],
    declarations: [
        IssuesExtListComponent,
        IssueExtDetailsComponent,
        IssueExtHeaderComponent,
        IssueExtElementsComponent,
        IssueExtElementModalComponent],
    providers: [IssuesExtRest, ProjectsRest, CustomersRest],
})
export class IssuesExtModule { }
